<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar"
    >
        <WidgetsList
            v-if="widgetList"
            :widgetList="widgetList"
            @go-to-widget="goToWidget"
            @go-to-hotspot="goToHotspot"
            @go-to-configurable-tour="goToConfigurableTour"
        />
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import WidgetsList from '@/layout/sidebar/components/WidgetsList';

    export default {
        name: 'ProgramSidebar',
        components: {
            WidgetsList
        },
        props: [
            'widgetList',
            'handler'
        ],
        data: () => ({
            iframeWidgets: [
                'cityscan'
            ]
        }),
        computed: {
            ...mapGetters([
                'isOfflineMode',
                'isOnline'
            ])
        },
        mounted() {
            this.handler();
        },
        methods: {
            goToWidget(widget, subitem) {
                if (this.iframeWidgets.includes(widget.id))
                    this.loadIframeWidget(widget);
                else {
                    let hasActiveHotspot = false;
                    if (widget.active)
                        if (widget.hotspots) {
                            let activeHotspot = widget.hotspots.filter(hotspot => hotspot.active);
                            if (activeHotspot.length)
                                hasActiveHotspot = true;
                        }

                    if ((!hasActiveHotspot && !widget.active) || (hasActiveHotspot && widget.active))
                        EventBus.$emit('program_SetActive', widget, subitem);
                }
            },
            goToHotspot(widget, hotspot) {
                EventBus.$emit('hotspot_setActive', widget, hotspot);
            },
            goToConfigurableTour(widget, configurableTour) {
                EventBus.$emit('configurableTour_setActive', widget, configurableTour);
            },
            loadIframeWidget(widget) {
                EventBus.$emit('program_SetActive', widget, null);
                EventBus.$emit('loadIframeWidget', widget.id, widget.url);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/sidebar/program/ProgramSidebar.vue